export enum ReplenishmentErrorCodes {
  BAD_REQUEST = "BAD_REQUEST",
  ORDER_NOT_FOUND = "ORDER_NOT_FOUND",
  INVALID_ORDER_ITEMS = "INVALID_ORDER_ITEMS",
}
